export default __webpack_public_path__ + "static/media/firebomb.09ead724.png";